import RequestHelper, {ActionAnswer, CommandData} from "../utils/RequestsHelper"
import {AxiosPromise} from "axios"
import {SelectProductsState} from "../components/SelectProductsCategoriesOrSets";


export default class StockSettingsApi {
    public static getSettings(): AxiosPromise<ActionAnswer<StockSettings>> {
        return RequestHelper.send("get", "stockSettings")
    }

    public static updateWarehouses(): AxiosPromise<ActionAnswer<IWarehouse[]>> {
        return RequestHelper.send("get", "stockSettings&action=updateWarehouses")
    }

    public static saveWarehouse(warehouse: IWarehouse): AxiosPromise<ActionAnswer<any>> {
        return RequestHelper.send("post", "stockSettings&action=saveOzonWarehouseSettings", warehouse)
    }

    public static setProductSyncBy(value: string): AxiosPromise<ActionAnswer<string>> {
        return RequestHelper.send("post", "stockSettings&action=productSyncBy", {value})
    }

    public static getProductSyncBy(): AxiosPromise<ActionAnswer<string>> {
        return RequestHelper.send("get", "stockSettings&action=productSyncBy")
    }

    public static setHistoryDaysKeep(value: number): AxiosPromise<ActionAnswer<number>> {
        return RequestHelper.send("post", "stockSettings&action=historyDaysKeep", {value})
    }

    public static getHistoryDaysKeep(): AxiosPromise<ActionAnswer<number>> {
        return RequestHelper.send("get", "stockSettings&action=historyDaysKeep")
    }

}

export interface StockSettings {
    warehouses: IWarehouse[],
    shop_warehouses: shopWarehouse[],
    syncProducts: CommandData
    syncStock: CommandData
    isExportAll: boolean,
    ozonWarehouse: string,
    productSyncBy: string
    defaultStockCount: number
    historyDaysKeep: number
}

export interface IWarehouse {
    id: string,
    is_rfbs: boolean,
    name: string,
    infinity_count: string,
    stock_mode: "all" | "selected",
    update_stocks: boolean,
    stocks: string[],
    write_off_goods: boolean,
    not_found_zero: boolean,
    conditions: IWarehouseCondition[],
    productCollectionSettings: SelectProductsState
}
export interface IWarehouseCondition {
    type: string,
    if_value: number,
    then_value: number
}
export interface shopWarehouse {
    id: string,
    low_count: string,
    critical_count: string,
    sort: string,
    name: string,
    public: string
}